import DeleteFailedRecordingModal from "@/components/DeleteFailedRecordingModal";
import RecordingUploadInterruptedModal from "@/components/RecordingUploadInterruptedModal";
import { useAppModal } from "@/contexts/AppModal/useAppModal";
import { Recording } from "@/models/recording";
import { ButtonSize, ButtonVariant, IconButton, InformationFilledIcon } from "@enxcs/dap-ui-stratos";
import { lazy, type FC } from "react";

const RetryFailedRecordingModal = lazy(() => import("@/components/RetryFailedRecordingModal"));
import { useTranslation } from "react-i18next";

type FailActionsIndexedDBProps = {
  recording: Recording;
};

const FailActionsIndexedDB: FC<FailActionsIndexedDBProps> = ({ recording }) => {
  const { t } = useTranslation();

  const { recordingId } = recording;

  const { onOpenModal } = useAppModal();

  const handleDelete = () => {
    onOpenModal(<DeleteFailedRecordingModal recordingId={recordingId} />);
  };

  const handleRetry = () => {
    onOpenModal(<RetryFailedRecordingModal recording={recording} />);
  };

  const handleResolveUpload = () => {
    onOpenModal(<RecordingUploadInterruptedModal recording={recording} handleRetry={handleRetry} handleDelete={handleDelete} />);
  };

  return <IconButton icon={InformationFilledIcon} title={t("recordsList.resolve")} size={ButtonSize.S} variant={ButtonVariant.GHOST} onClick={handleResolveUpload} />;
};

export default FailActionsIndexedDB;
